import {defaultProducto, motivo, defaultCompaniesAssignProduct} from './state';
import {defaultCas} from './cas/state';
import {defaultselectedUn} from './sistemasclasificacion/nacionesunidas/state';
import {defaultNfpa} from './sistemasclasificacion/nfpa/state';

/**
 * Mutación que carga los estados de un producto químico en el formulario.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} estados contiene la información de los estados de un producto químico.
 */
export function cargarEstados(state, estados) {

    state.estados = [];

    for (var i = 0; i < estados.length; i++) {
        state.estados.push({value: estados[i].id, text: estados[i].lista});
    }

}

/**
 * Mutación que carga los existe o no existe de un producto químico en el formulario.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} control_existe la información de los existe o no existe de un producto químico.
 */
export function CargarExisteNoExiste(state, control_existe) {

    state.control_existe = [];

    for (var i = 0; i < control_existe.length; i++) {
        state.control_existe.push({value: control_existe[i].id, text: control_existe[i].lista});
    }

}

/**
 * Mutación que verifica el qr
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} estados contiene la información de los estados de un producto químico.
 */
export function setQr(state, qr) {
    state.check_qr = qr.qr;
    state.mini = qr.etiqueta_mini;
    state.etiqueta_resolucion = qr.etiqueta_resolucion;
    state.etiqueta_vertical = qr.etiqueta_vertical;
    let formatosEtiqueta = [];
    qr.etiqueta_pdf == 1 ? formatosEtiqueta.push({'value': 'Pdf', 'text': 'Pdf'}) : '';
    qr.etiqueta_word == 1 ? formatosEtiqueta.push({'value': 'Word', 'text': 'Word'}) : '';
    state.formatosEtiqueta = formatosEtiqueta;
}

/**
 * Mutación para obtener los tipos de productos existentes
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} tipoProductos contiene la información de los tipos de productos.
 */
export function setTipoProductos(state, tipoProductos) {
    state.tipoProductos = tipoProductos;
}


export function setEspeciales(state, especial) {
    if (!especial.qr) {
        state.mini = 0;
        state.check_qr = 0;
        state.etiqueta_vertical = 1;
        state.etiqueta_resolucion = 1;
        state.formatosEtiqueta = [{'value': 'Pdf', 'text': 'Pdf'}];
    } else {
        state.mini = especial.qr.etiqueta_mini;
        state.check_qr = especial.qr.qr;
        state.etiqueta_vertical = especial.qr.etiqueta_vertical;
        state.etiqueta_resolucion = especial.qr.etiqueta_resolucion;
        let formatosEtiqueta = [];
        especial.qr.etiqueta_pdf === 1 ? formatosEtiqueta.push({'value': 'Pdf', 'text': 'Pdf'}) : '';
        especial.qr.etiqueta_word === 1 ? formatosEtiqueta.push({'value': 'Word', 'text': 'Word'}) : '';
        state.formatosEtiqueta = formatosEtiqueta;
    }
}

/**
 * Mutación que carga la información de un producto químico.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} product contiene la información del producto químico.
 */
export function setProduct(state, product) {
    const moment = require('moment');
    state.selectedProduct = product;
    state.selectedProduct.doc_sga = product.adjuntos.length > 0 ? 160 : 161;
    state.selectedProduct.doc_etiqueta = product.sga.length > 0 ? 160 : 161;

    let fecha_etiqueta = '';

    if (state.selectedProduct.doc_etiqueta === 160) {
        fecha_etiqueta = moment(product.sga[0].updated_at).format('YYYY-MM-DD');
    }

    state.selectedProduct.fecha_etiqueta = fecha_etiqueta;

    if (product.tipoproducto) {
        state.selectedProduct.tipoproducto = parseInt(product.tipoproducto);
    }
}

/**
 * Mutación que carga la información de los productos químicos.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} producto contiene la informacion de los productos químicos.
 */
export function setProducto(state, producto) {
    state.selectedProduct = producto.data;
}

/**
 * Mutación que cambia la accion a actualizar.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 */
export function guardaProducto(state) {
    state.accion = 'update';
}

/**
 * Mutación para resetear los productos
 *
 * @param {*} state contiene la información de variables del formulario.
 */
export function resetProductos(state)
{
    state.productos = {data: []}
}

/**
 * Mutación para cargar la informacion del producto en el buscador de productos.
 *
 * @param {*} state contiene la información de variables del formulario.
 * @param {*} productos contieme la información de los productos químicos.
 */
export function setProductos(state, productos) {

    if (!productos.data || typeof productos.data !== 'object' || productos.data.length <= 0) {
        state.productos = {data: []}
        return false;
    }

    productos.data.forEach(element => {
        if (element.sga === null) element.vacio = true;
        if (element.u_n) {
            if (element.u_n.riesgo_principal == '' && element.u_n.riesgo_secundario == '' && element.u_n.riesgo_secundario1 == '') {
                element.vacio = true;
                element.un = true;
            }
        }
        if (element.u_n === null) {
            element.vacio = true;
            element.un = true;
        }
        if (element.hmis_fisico === null) element.hmisData = 'NO';
        if (element.hmis_personal === null) element.hmisData = 'NO';
        if (element.hmis_salud === null) element.hmisData = 'NO';
        if (element.nfpa === null) element.vacio = true;
    });
    state.productos = productos;

}

export function setProductosContratistas(state, productos_contratistas) {
    state.productos_contratistas = productos_contratistas;
}

export function setProductosTemporales(state, productos_temporales) {
    state.productos_temporales = productos_temporales;
}

/**
 * Mutación para cargar los errores del proceso de productos químicos.
 *
 * @param {*} state contiene la información de variables del formulario.
 * @param {*} error contiene el error que arroja el sistema.
 */
export function productError(state, error) {
    state.error = error;
}

/**
 * Mutación para cargar la informacion de productos químicos.
 *
 * @param {*} state contiene la información de variables del formulario.
 * @param {*} buscar contiene la información de la busqueda.
 */
export function setFiltro(state, buscar) {
    /*if (buscar != state.filtro.nombre) {
        state.filtro.page = 1;
    }*/
    state.filtro.page = 1;
    state.filtro = buscar;
}

/**
 * Mutación para cargar la informacion de productos químicos.
 *
 * @param {*} state contiene la información de variables del formulario.
 * @param {*} empresa contiene la información de la busqueda.
 */
export function setFiltroEmpresa(state, empresa) {
    if (!state.esEmpresaContratista) {
        state.filtro.empresa = empresa;
        state.filtro.vistaEmpresa = true;
    }
}

/**
 * Mutación para cargar la informacion de productos químicos.
 *
 * @param {*} state contiene la información de variables del formulario.
 * @param {*} empresa contiene la información de la busqueda.
 */
export function setUbicacioneEmpresa(state, ubicaciones) {

    state.ubicEmpresa = ubicaciones;
}

/**
 * Mutación para cargar la informacion de productos químicos.
 *
 * @param {*} state contiene la información de variables del formulario.
 * @param {*} empresa contiene la información de la busqueda.
 */
 export function setArbolEmpresa(state, ubicaciones) {
    state.arbolUbicaciones = ubicaciones;
}

/**
 * Mutación para cargar la informacion de productos químicos.
 *
 * @param {*} state contiene la información de variables del formulario.
 * @param {*} empresa contiene la información de la busqueda.
 */
export function setFiltroUbicacion(state, ubicaciones) {
    state.filtro.ubicaciones = ubicaciones;

}

/**
 * Mutación para cargar las empresas registradas en el sistema.
 *
 * @param {*} state contiene la información de variables del formulario.
 * @param {*} empresas contiene la información de las empresas.
 */
export function setListaEmpresa(state, empresas) {
    state.empresas = empresas.data;
    state.selectedEmpresas.empresas = empresas.data;
    state.selectedEmpresasInventario.empresas = empresas.data;
}


/**
 * Mutación limpiar el listado de
 *
 * @param {*} state contiene la información de variables del formulario.
 * @param {*} bases contiene la información de las bases.
 */
export function setLimpiarEmpresas(state, bases) {
    state.empresas = [];
}

/**
 * Mutación para cargar las áreas del producto químico.
 *
 * @param {*} state contiene la información de variables del formulario.
 * @param {*} areas contiene la información de las áreas.
 */
export function setListaAreas(state, areas) {
    state.areas = areas;
}

/**
 * Mutación para cargar los campos del producto químico.
 *
 * @param {*} state contiene la información de variables del formulario.
 * @param {*} campos contiene la información de los campos del producto químico.
 */
export function setListaCampos(state, campos) {
    state.campos = campos;
}

export function setFiltroBases(state, bases) {
    state.filtro.base = bases;
}

export function setFiltroAreas(state, areas) {
    state.filtro.area = areas;
}

export function setAccion(state, accion) {
    state.accion = accion;
}

export function setComponente(state, componente) {
    let componentesactivos = [];

    componente.forEach(ele => {
        componentesactivos.push(ele.componenteAct);
    });
    state.selectedProduct.componentesactivos = componentesactivos.toString();
}


export function setPermisosAdmin(state, permiso) {
    state.esAdmin = permiso;
}

export function setPermisosEmpresa(state, permiso) {
    if (!state.esAdmin) {
        state.esEmpresa = permiso;
    }
}


export function asignaRol(state, rol) {
    state.esAdmin = false;
    state.esAdminTec = false;
    state.esEmpresaContratista = false;
    state.esEmpresa = false;
    state.esHse = false;

    let roles = rol.split(',');
    roles.forEach(rol => {
        if (rol == 'admin' || rol == 'superadmin' || rol == 'admin-ma') {
            state.esAdmin = true;
        } else if (rol == 'empresa') {
            state.esEmpresa = true;
        } else if (rol == 'empresa-hse') {
            state.esHse = true;
        } else if (rol == 'admin-tecnico') {
            state.esAdminTec = true;
        } else if (rol == 'empresa-contratista') {
            state.esEmpresaContratista = true;
        }
    });
}

export function resetFiltro(state) {
    state.filtro.empresa = '';
    state.filtro.proveedor = '';
    state.filtro.nombre = '';
    state.filtro.sinonimos = '';
    state.filtro.id_fabricante = null;
    state.filtro.confecha = ['', ''];
    state.filtro.ubicaciones = [];
    state.filtro.campoPersonalizado = '';
    state.filtro.valorcampo = '';
    state.filtro.campo = '';
    state.filtro.page = 1;
    state.filtro.perPage = 10;
    state.filtro.sortBy = 'id';
    state.filtro.sort = 'DESC';
    state.filtro.contratista = '';
    state.filtro.tipo_producto = [];
    state.filtro.pago = false;
    state.filtro.asignado = false;
    state.filtro.bloqueado = false;
    state.filtro.estado = null;
    state.filtro.component = null;
    state.filtro.component = null;
    state.filtro.year_import = null;
    state.filtro.is_imported = false;
    state.filtro.in_use = 1;
    state.filtro.is_made = false;
    state.filtro.cas = '';
    state.filtro.tipo = '';
    state.filtro.cumplimiento = '';
    state.filtro.comments = '';
    state.filtro.product_without_company = false;
    state.filtro.product_status = null;
    state.filtro.without_location = false;
}

export function setPago(state, pago) {
    state.pago = pago;
}

export function cambiaLoadingBasesAreas(state, estado) {
    state.loadingBasesAreas = estado;
}

// paginacion
export function setPage(state, page) {
    state.filtro.page = page;
}

//cantidad de registros por pagina
export function setPerPage(state, perPage) {
    state.filtro.page = 1;
    state.filtro.perPage = perPage;
}

export function asignaEmpresa(state, id) {
    state.id_empresa = id;
}

export function cambiaPermisoGuardar(state, estado) {
    state.opcionGuardar = estado;

}

//limpia campos
export function resetSelectedProducto(state) {
    state.selectedProduct = { ...defaultProducto() };
}

export function setContratistas(state, listado) {
    state.contratistas = listado;
}

export function setUbicaciones(state, ubicacion) {
    state.ubicaciones = ubicacion;
}

export function setUbicacionesContratistas(state, ubicacionesContratista) {
    state.ubicacionesContratista = ubicacionesContratista;
}

export function asignaRolProductos(state, rol) {
    //  state.rolProductos = rol;
    if (rol == 'admin' || rol == 'superadmin') {
        state.esAdmin = true;
    } else if (rol == 'empresa' || rol == 'empresa-hse') {
        state.esEmpresa = true;
    } else if (rol == 'admin-tecnico') {
        state.esAdminTec = true;
    } else if (rol == 'empresa-contratista') {
        state.esEmpresaContratista = true;
    }
}

/**
 * Establece un valor para esEmpresaContratista
 * @param state
 * @param esEmpresaContratista Contiene el valor a establecer
 * @author Jhon García
 */
export function setEsEmpresaContratista(state, esEmpresaContratista) {
    state.esEmpresaContratista = esEmpresaContratista;
}

export function establecerFabricantesFiltro(state, fabricantes) {
    state.fabricantes_filtro = fabricantes;
}

export function establecerEmpresasFiltro(state, empresas) {
    state.empresas_filtro = empresas;
}


export function establecerCargandoDatosSelect(state, cargando_datos_select) {
    state.cargando_datos_select = cargando_datos_select;
}

/**
 * Establecer un valor para modal_desbloqueo.ver
 */
export function establecerModalDesbloqueo(state, ver) {
    state.modal_desbloqueo.ver = ver;
}

/**
 * Restablecer el valor por defecto del motivo
 */
export function restablecerMotivo(state) {
    state.motivo = motivo();
}

/**
 * Establecer el valor para id_producto del motivo
 */
export function establecerIdProductoMotivo(state, id_producto) {
    state.motivo.id_producto = id_producto;
}

/**
 * Establecer un valor para motivos
 */
export function establecerMotivos(state, motivos) {
    state.motivos = motivos;
}

/**
 * Establece un valor para fabricantes
 * @param state
 * @param fabricantes Contiene el valor a establecer
 * @author Jhon García
 */
export function setFabricantes(state, fabricantes) {
    state.fabricantes = fabricantes;
}

export function establecerEmpresas(state, empresas) {
    state.empresas = empresas;
}

export function setProductoNuevo(state, producto_nuevo) {
    state.producto_nuevo = producto_nuevo;
}

export function setTabActivo(state, activo) {
    state.tabs.activo = activo;
}

/**
 * Establecer un valor para la variable proveedores.
 */
export function setProviders(state, proveedores) {
    state.proveedores = proveedores;
}

/**
 * Establecer un valor para el atributo empresa de la variable filtro.
 */
export function setEmpresaToFiltro(state, empresa) {
    state.filtro.empresa = empresa;
}

/**
 * Establecer un valor para la variable empresas_proveedor.
 */
export function setEmpresasProveedor(state, empresas_proveedor) {
    state.empresas_proveedor = empresas_proveedor;
}

/**
 * Establecer fichas de seguridad de un producto.
 */
export function SetSafetyDataSheets(state, SafetyDataSheets) {
    state.safety_data_sheets = [];
    SafetyDataSheets.forEach(element => {
        state.safety_data_sheets.push({
            type: element.tipo == 155 ? 'MSDS' : 'FDS',
            file:window.URL.createObjectURL(convertBase64FiletoBlob(element.fileBase64))
        });
    });
}

/**
 * Convertir datos del pdf obtenido en base64 a tipo Blob.
 *
 * @param {*} fileBase64: archivo en base 64 que se quiere formatear y devolver en Blob
 * @param {*} contentType: tipo de contenido, ejemplo: 'application/pdf'
 * @returns string
 * @author Luis Almendrales
 */
function convertBase64FiletoBlob(fileBase64, contentType = 'application/pdf; application/octet-stream') {

    //application/octet-stream
    const byteArray = Uint8Array.from(window.atob(fileBase64).split('').map(char => char.charCodeAt(0)));

    return new Blob([byteArray], {
        type: contentType
    });
}

/**
 * Establecer las empresas asignadas y MYS de un producto.
 *
 * @param state
 * @param companies_assign_product Contiene las empresas asignadas y MYS de un producto.
 * @author Brandon Torres
 */
export function setCompaniesAssignProduct(state, companies_assign_product) {
    state.companies_assign_product = companies_assign_product;
}

/**
 * Setea el valor de la propeidad modalReadPdf del state.
 * @param state
 * @returns void
 */
export function setModalReadPdf(state) {
    state.modalReadPdf = !state.modalReadPdf;
}

/**
 * Establecer el valor de la propiedad modalReadPdf del state.
 * @param state
 * @param value Contiene el valor a establecer en la propiedad modalReadPdf del state.
 * @returns void
 */
export function updateSelectedProduct(state, newData) {
    state.selectedProduct.nombre =
        newData.Nombre || state.selectedProduct.nombre;
    state.selectedProduct.sinonimos =
        newData.Sinonimos ||
        newData.Sinónimos ||
        newData.Sinnimos ||
        "NO REGISTRA";
    state.selectedProduct.uso = newData.Uso || "NO REGISTRA";
    state.selectedProduct.observacion =
        newData.Observaciones == "NO REGISTRA" ? "" : newData.Observaciones;

    const disposicionKeys = [
        "Disposicion y Tratamiento",
        "Disposición y Tratamiento",
        "Disposicin y Tratamiento",
    ];

    const disposicionKey = disposicionKeys.find(
        (key) => newData[key] && newData[key] !== "NO REGISTRA"
    );

    state.selectedProduct.disposicion = disposicionKey
        ? newData[disposicionKey]
        : "LOS RESIDUOS DE ESTE PRODCUCTO DEBE CONSIDERARSE COMO PELIGROSOS. DISPONER DE ACUERDO A LA NORMATIVA AMBIENTAL NACIONAL, REGIONAL Y LOCAL VIGENTE";

    const casKeys = ["Numero CAS", "Número CAS", "Nmero CAS"];
    const casKey = casKeys.find(
        (key) => newData[key] && newData[key] !== "NO REGISTRA"
    );
    state.selectedProduct.cas = casKey ? newData[casKey] : "MEZCLA";

    let stateProduct =
        newData["Estado fisico"] ||
        newData["Estado físico"] ||
        newData["Estado fsico"];
    if (stateProduct) {
        stateProduct = stateProduct.toLowerCase();

        if (["solido", "sólido", "slido"].includes(stateProduct))
            state.selectedProduct.estado = 131;
        if (["liquido", "líquido", "lquido"].includes(stateProduct))
            state.selectedProduct.estado = 132;
        if (["gaseoso"].includes(stateProduct))
            state.selectedProduct.estado = 133;
    }

    if (newData["Tipo de producto"]) {
        switch (newData["Tipo de producto"].toLowerCase()) {
            case "mezcla":
                state.selectedProduct.tipoproducto = 180;
                break;
            case "solución / dilución":
                state.selectedProduct.tipoproducto = 181;
                break;
            case "sustancia":
                state.selectedProduct.tipoproducto = 184;
                break;
            case "por verificar":
                state.selectedProduct.tipoproducto = 185;
                break;
            default:
                state.selectedProduct.tipoproducto = 180;
                break;
        }
    }
}

/**
 * Setear el id_fabricante del producto seleccionado.
 * @param state
 * @param id Contiene el id del fabricante a establecer en el producto seleccionado.
 * @returns void
 */
export function setIdFabricante(state, id) {
    state.selectedProduct.id_fabricante = id;
}

/**
 * Establecer los fabricantes en el state.
 * @param state
 * @param producers Contiene los fabricantes a establecer en el state.
 * @returns void
 */
export function setProducersFilter(state, producers) {
    state.fabricantes_filtro = producers;
}

/**
 * Establecer el valor de la propiedad components del state.
 * @param state
 * @param components Contiene los componentes a establecer en el state.
 * @returns void
 */
export function setComponentsReadFds(state, components) {
    const newComponents = components
        .filter(
            (component) =>
                component["Número CAS del componente"] &&
                component["Nombre del componente"] &&
                component["Porcentaje"]
        )
        .map((component) => {
            let percentage = component["Porcentaje"].replace("%", "").trim();
            let symbolFrom = "=";
            let symbolTo = null;
            let from = null;
            let to = null;

            const rangeFound = percentage.match(/-/);
            if (rangeFound) {
                [from, to] = percentage
                    .split("-")
                    .map((num) => num.replace(/(<=|>=|<|>|=)/g, "").trim());
                symbolFrom = ">=";
                symbolTo = "<=";
            } else {
                from = percentage.replace(/(<=|>=|<|>|=)/g, "").trim();
            }

            return {
                cas: component["Número CAS del componente"],
                name: component["Nombre del componente"],
                from: parseInt(from),
                to: parseInt(to),
                symbol_from: symbolFrom,
                symbol_to: symbolTo,
            };
        }).filter(component => (component.to >= 0 && component.from >= 0));

    state.componentsReadFds = newComponents;
}

/**
 * Restablecer el valor de la propiedad components del state.
  * @param state
 * @returns void
 */
export function resetComponentsReadFds(state) {
    state.componentsReadFds = [];
}

/**
 * Establecer el valor de la propiedad fileFdsPdf del state.
 *
 * @param state
 * @param file Contiene el archivo a establecer en el state.
 * @returns void
 */
export function setFileFdsPdf(state, file) {
    state.fileFdsPdf = file;
}

/**
 * Establecer el valor de la propiedad typeDocumentIa del state.
 *
 * @param state
 * @param type Contiene el tipo de documento a establecer en el state.
 * @returns void
 */
export function setTypeDocumentIa(state, type) {
    state.typeDocumentIa = type;
}

/**
 * Establecer el valor de la propiedad dateDocumentIa del state.
 *
 * @param state
 * @param date Contiene la fecha del documento a establecer en el state.
 * @returns void
 */
export function setDateDocumentIa(state, date) {
    state.dateDocumentIa = date;
}

/**
 * Restablecer el valor de la propiedad sga del state.
 * @param state
 * @returns void
 */
export function resetSgaReadFds(state) {
    state.sgaReadFds = [];
}

/**
 * Establecer el valor de la propiedad sga del state.
 * @param state
 * @param sga Contiene el sga a establecer en el state.
 * @returns void
 */
export function setSgaReadFds(state, sga) {
    state.sgaReadFds = sga;
}

/**
 * Establecer el valor del campo show_info para ocultar la información del producto en el rol empresa.
 * @param state
 * @param show_info Bandera.
 * @param in_use Información de producto en uso.
 * @returns void
 */
export function setShowInfo(state, {show_info, in_use}) {
    state.show_info = show_info;
    state.in_use = in_use;
}

/**
 * Mutación que agregar un producto a los seleccionados.
 *
 * @author Libardo Bolaño
 * @param {*} state contiene los productos seleccionados.
 * @param {number} product contiene el producto a agregar.
 */
export function updateSelecteProducts(state, product) {
    const selectedProdutIds = state.selectedProducts;
    if(state.selectedProducts.find(e=>e.id===product.id) !== undefined) {
        state.selectedProducts = selectedProdutIds.filter(e=>e.id!==product.id);
    }else state.selectedProducts.push(product);
}

/**
 * Mutación Limpia la lista de productos seleccionados.
 *
 * @author Libardo Bolaño
 * @param {*} state contiene los productos seleccionados.
 */
export function resetSelecteProducts(state) {
    state.selectedProducts = [];
}

/**
 * Establecer el valor de la propiedad dateDocumentIaExpiration del state.
 *
 * @param state
 * @param date Contiene la fecha del documento a establecer en el state.
 * @returns void
 */
export function setDateDocumentIaExpiration(state, date) {
    state.dateDocumentIaExpiration = date;
}



/**
 * Establecer el valor de la propiedad add_product_company.
 *
 * @param state
 * @param addProductCompany valor a asignar a la propiedad.
 * @returns void
 */
export function setAddProductCompany(state, addProductCompany) {
    state.addProductCompany = addProductCompany;
}


/**
 * Agregar Los productos que la empresa puede seleccionar al estado.
 *
 * @param {*} state
 * @param {*} products
 */
export function setProductsToAssing(state, products) {
    state.productsToAssing = products
}


/**
 * actualizar la cantidad de productos disponibles para agregar en el estado.
 *
 * @param {*} state
 * @param {*} products
 */
export function setAvailableQuantity(state, quantity) {
    state.availableQuantity = quantity
}

/**
 * Mostrar/Ocultar contenido - carga archivo Excel.
 *
 * @param Object state
 * @param Boolean nextState
 */
export function setUpFileExcelShow(state, nextState) {
    state.upFileExcelShow = nextState
}

/**
 * Establecer el respuesta del proceso de cargar archivo excel con los productos.
 * 
 * @param Object state 
 * @param Object nextState 
 */
export function setResponseUpFileExcelProducts(state, nextState) {
    state.responseUpFileExcelProducts = nextState
}

/**
 * Establecer historico de productos actualizados.
 * 
 * @param Object state
 * @param Boolean nextState
 */
export function setHistoryRegistersProducts(state, nextState) {
    state.historyRegistersProducts = nextState
}

/**
 * Establecer historico de productos actualizados a datos iniciales.
 * 
 * @param Object state
 */
export function resetHistoryRegistersProducts(state) {
    state.historyRegistersProducts = defaultCompaniesAssignProduct()
}

/**
 * Establecer el estado de la carga del historico de productos actualizados.
 * 
 * @param Object state
 * @param Boolean nextState
 */
export function setHistoryRegistersProductsLoading(state, nextState) {
    state.historyRegistersProductsLoading = nextState
}
